var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-message',_vm._b({},'chat-message',_vm.chatMessage,false))}
var staticRenderFns = []

export { render, staticRenderFns }